<template>
</template>

<script>

import { mapGetters } from "vuex";

import AccessCodeCardBody from "@/templates/faux_marriott_gpns/components/AccessCodeCardBody";
import AccessCodeLink from "@/templates/faux_marriott_gpns/components/AccessCodeLink";
import AddDeviceLink from "@/templates/faux_marriott_gpns/components/AddDeviceLink";
import AlreadyPurchased from "@/templates/faux_marriott_gpns/components/AlreadyPurchased";
import BaseMethodCardDuration from "@/templates/faux_marriott_gpns/components/BaseMethodCardDuration";
import BaseMethodCardInfo from "@/templates/faux_marriott_gpns/components/BaseMethodCardInfo";
import BaseMethodCardPricing from "@/templates/faux_marriott_gpns/components/BaseMethodCardPricing";
import BaseMethodCards from "@/templates/faux_marriott_gpns/components/BaseMethodCards";
import CreditCardBody from "@/templates/faux_marriott_gpns/components/CreditCardBody";
import CreditCardLink from "@/templates/faux_marriott_gpns/components/CreditCardLink";
import EmailFieldContainer from "@/templates/faux_marriott_gpns/components/EmailFieldContainer";
import FieldFirstName from "@/templates/faux_marriott_gpns/components/FieldFirstName";
import FieldFirstnameWelcome from "@/templates/faux_marriott_gpns/components/FieldFirstnameWelcome";
import FieldLastName from "@/templates/faux_marriott_gpns/components/FieldLastName";
import FieldLastnameWelcome from "@/templates/faux_marriott_gpns/components/FieldLastnameWelcome";
import FieldRoom from "@/templates/faux_marriott_gpns/components/FieldRoom";
import FieldRoomWelcome from "@/templates/faux_marriott_gpns/components/FieldRoomWelcome";
import KeepUpgradeContainer from "@/templates/faux_marriott_gpns/components/KeepUpgradeContainer";
import SelectedPricingContainer from "@/templates/faux_marriott_gpns/components/SelectedPricingContainer";
import StandardDurationOptions from "@/templates/faux_marriott_gpns/components/StandardDurationOptions";
import TroubleContainer from "@/templates/faux_marriott_gpns/components/TroubleContainer";
import UpgradeLink from "@/templates/faux_marriott_gpns/components/UpgradeLink";
import UpgradeOtherContainer from "@/templates/faux_marriott_gpns/components/UpgradeOtherContainer";

export default {
  name: "Index",
  computed: {
    ...mapGetters(["entity"])
  }
}

</script>

<style scoped>
</style>